export default class Mobile {
 	getIosBrowser() {
		let userAg = navigator.userAgent.toLowerCase();
		if (userAg.indexOf('safari') !== -1) {
			if (userAg.indexOf('chrome') > -1) {
				return 'chrome';
			} else {
				return 'safari';
			}
		}
	}

	checkMobile = () => {
		if (
			navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPod/i) ||
			navigator.userAgent.match(/BlackBerry/i) ||
			navigator.userAgent.match(/Windows Phone/i)
		)
			return true;
		return false;
	}

	checkLandscape = () => {
		return window.innerWidth > window.innerHeight;
	}

	isIpad = () => {
		return navigator.userAgent.match(/iPad/i) != null;
	}
}
  